import { render, staticRenderFns } from "./setShifts.vue?vue&type=template&id=b33552e8&"
import script from "./setShifts.vue?vue&type=script&lang=ts&"
export * from "./setShifts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports